function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "cancel");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "cancel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "cancel",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.0420168,2.92436975 C15.1554622,1.03781513 12.6512605,0 9.98319328,0 C7.31512605,0 4.81092437,1.03781513 2.92436975,2.92436975 C1.03781513,4.81092437 0,7.31512605 0,9.98319328 C0,12.6512605 1.03781513,15.1554622 2.92436975,17.0420168 C4.81092437,18.9285714 7.31512605,19.9663866 9.98319328,19.9663866 C12.6512605,19.9663866 15.1554622,18.9285714 17.0420168,17.0420168 C18.9285714,15.1554622 19.9663866,12.6512605 19.9663866,9.98319328 C19.9663866,7.31512605 18.9285714,4.81092437 17.0420168,2.92436975 Z M16.2394958,16.2394958 C14.5672269,17.9117647 12.3445378,18.8319328 9.98319328,18.8319328 C7.62184874,18.8319328 5.39915966,17.9117647 3.72689076,16.2394958 C0.277310924,12.789916 0.277310924,7.17647059 3.72689076,3.72689076 C5.39915966,2.05462185 7.62184874,1.13445378 9.98319328,1.13445378 C12.3445378,1.13445378 14.5672269,2.05462185 16.2394958,3.72689076 C19.6890756,7.17647059 19.6890756,12.789916 16.2394958,16.2394958 Z",
  id: "Shape",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  x: 9.09090909,
  y: 7.27272727,
  width: 1.81818182,
  height: 9.09090909,
  rx: 0.909090909
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8-Copy",
  x: 9.09090909,
  y: 3.63636364,
  width: 1.81818182,
  height: 1.81818182,
  rx: 0.909090909
})));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.28031438.svg";
export { ForwardRef as ReactComponent };